import { render, staticRenderFns } from "./UploadPic.vue?vue&type=template&id=5e622c37&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./UploadPic.vue?vue&type=script&lang=js&"
export * from "./UploadPic.vue?vue&type=script&lang=js&"
import style0 from "./UploadPic.vue?vue&type=style&index=0&id=5e622c37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e622c37",
  null
  
)

export default component.exports